import React from "react";

import BaseListBox from "./BaseListBox";
import CheckboxSimple from "./CheckboxSimple";

/**
 * @typedef {Object} Props
 * @property {import("./CheckboxSimple").CheckBoxSimpleVariant=} color
 * @property {string=} customClass Class pour customiser le label du checkbox
 * @property {string=} className Class pour customiser le conteneur du checkbox
 */

/**
 *
 * @param {(import("./BaseListBox").BaseListBoxProps & Props)} props
 * @returns
 */
export default function ListboxSimple(props) {
  const {
    color,
    customClass,
    className,
    renderOptionLabel,
    disableTruncate,
    smartTooltip,
    ...baselistboxProps
  } = props;

  return (
    <BaseListBox
      {...baselistboxProps}
      hasRenderOptionLabel={Boolean(renderOptionLabel)}
    >
      {({
        option,
        selected,
        optionLabel,
        noRadio,
        recurrenceListBox,
        withTooltip,
        informations
      }) => (
        <CheckboxSimple
          id={option._id}
          label={
            typeof renderOptionLabel === "function"
              ? renderOptionLabel({ option, optionLabel, selected })
              : optionLabel
          }
          checked={selected}
          noRadio={Boolean(noRadio)}
          variant={color}
          recurrenceListBox={recurrenceListBox}
          withTooltip={withTooltip}
          smartTooltip={smartTooltip} 
          customClass={customClass}
          className={className}
          informations={informations}
          disableTruncate={Boolean(renderOptionLabel) || disableTruncate}
        />
      )}
    </BaseListBox>
  );
}
